import React, { useState } from 'react';
import StageBidding from './StageBidding';
import StageAcceptOffer from './StageAcceptOffer';
import StageMakePayment from './StageMakePayment';
import StageCloseTransaction from './StageCloseTransaction';
import { getToken } from '../utils';

function TrackTransactionStage({ content }) {
  const userId = getToken()?.user.id;
  const [isDisabled, setisDisabled] = useState(true);
  // const [disableBid, setDisableBid] = useState(true);

  // const [refresh, setRefresh] = useState(true);
  // let url;
  // let data;

  const {
    getDataById,
    handleOpenandCloseModal,
    openModal,
    clickedBidChatUser,
    handleToast,
    userToken,
    bidUsers,
    handleHideRating,
  } = content;

  // const trxoriginatorId = clickedBidChatUser?.chats[0]?.orginator?.id;
  // const TrackDatas = [
  //   {
  //     tracker: '1',
  //     title: 'Bid Offers',
  //     body: 'Buyer $20,000/800',
  //     button: (
  //       <button
  //         className='py-1.5 bg-b-mc text-p-wh rounded text-xs w-16 disabled:bg-p-bk/5 hover:bg-b-mc/75 focus:bg-b-mc/80'
  //         //   onClick={handleShowandHideBidForm}
  //         //   disabled={}
  //       >
  //         Bid
  //       </button>
  //     ),
  //   },
  //   {
  //     tracker: '2',
  //     title: 'Accept Offer',
  //     body: 'Accept offer at current rate',

  //     button: (
  //       <button
  //         className='py-1.5 bg-b-mc text-p-wh disabled:bg-p-bk/5 rounded text-xs w-16 hover:bg-b-mc/75 focus:bg-b-mc/80'
  //         //   onClick={handleShowandHideAcceptModal}
  //         //   disabled={ }
  //       >
  //         Accept
  //       </button>
  //     ),
  //   },
  //   {
  //     tracker: '3',
  //     title: 'Make Payment',
  //     body: 'Buyer ammount/rate $20,000/800',

  //     button: (
  //       <button
  //         className='py-1.5 bg-b-mc text-p-wh rounded text-xs w-16 disabled:bg-p-bk/5 hover:bg-b-mc/75 focus:bg-b-mc/80'
  //         //   onClick={handleShowBankDetails}
  //         // disabled={
  //         //   (getDataById?.originator?.id === userId &&
  //         //     getDataById?.payment_status?.id !== 3) ||
  //         //   (bidUsers[0]?.user?.id === userId &&
  //         //     getDataById?.transaction_status?.id !== 5)
  //         // }
  //       >
  //         Pay
  //       </button>
  //     ),
  //   },
  //   {
  //     tracker: '4',
  //     title: 'Close transaction',
  //     body: 'Please confirmed that you have recieve payment to close transaction',
  //     button: (
  //       <button
  //         className='py-1.5 bg-b-mc text-p-wh rounded text-xs w-16 disabled:bg-p-bk/5 hover:bg-b-mc/75 focus:bg-b-mc/80'
  //         //   onClick={handleShowCloseTansactionModal}
  //         //   disabled={
  //         //     (getDataById?.originator?.id === userId &&
  //         //       getDataById?.payment_status?.id !== 6) ||
  //         //     (bidUsers[0]?.user?.id === userId &&
  //         //       getDataById?.payment_status?.id !== 4)
  //         //   }
  //       >
  //         Close
  //       </button>
  //     ),
  //   },
  // ];

  const originator =
    getDataById?.originator?.id === userId &&
    clickedBidChatUser?.bidder_accepted === '1' &&
    clickedBidChatUser?.offer_owner_accepted === '1';

  const disableBid =
    (getDataById?.originator?.id === userId && getDataById?.bid_count === 0) ||
    getDataById?.payment_status?.name !== 'Pending' ||
    clickedBidChatUser?.offer_owner_accepted === '1';

  const disableAccept =
    getDataById?.bid_count === 0 ||
    (clickedBidChatUser?.bidder_accepted === '1' &&
      clickedBidChatUser?.offer_owner_accepted === '1');

  const disablePayment =
    getDataById?.transaction_type?.name === 'Buy'
      ? (originator && getDataById?.payment_status?.name === 'Pending') ||
        (getDataById?.originator?.id !== userId &&
          getDataById?.payment_status?.id === 3) || (getDataById?.direct_trade === '1' && getDataById?.payment_status?.name === 'Pending')
      : (getDataById?.originator?.id !== userId &&
          clickedBidChatUser?.bidder_accepted === '1' &&
          clickedBidChatUser?.offer_owner_accepted === '1' &&
          getDataById?.payment_status?.id === 1) ||
        (originator && getDataById?.payment_status?.id === 3)  || (getDataById?.direct_trade === '1' && getDataById?.payment_status?.id === 3);

  const disableCloseAccount =
    getDataById?.transaction_type?.name === 'Buy'
      ? (originator &&
          getDataById?.payment_status?.id === 4) ||
        (getDataById?.originator?.id !== userId &&
          getDataById?.payment_status?.id === 8) || (getDataById?.direct_trade === '1' && getDataById?.payment_status?.id === 4)
      : (getDataById?.originator?.id !== userId &&
          getDataById?.payment_status?.id === 4) ||
        (originator && getDataById?.payment_status?.id === 8) || (getDataById?.direct_trade === '1' && getDataById?.payment_status?.id === 8);

  // console.log({
  //   getDataById,
  //   disablePayment,
  //   clickedBidChatUser,
  // });

  return (
    <div className='w-full grid md:grid-cols-4 gap-6 justify-evenly'>
      <StageBidding
        content={{
          getDataById,
          handleOpenandCloseModal,
          openModal,
          clickedBidChatUser,
          handleToast,
          isDisabled,
          setisDisabled,
          disableBid,
        }}
      />
      <StageAcceptOffer
        content={{
          getDataById,
          handleOpenandCloseModal,
          openModal,
          handleToast,
          clickedBidChatUser,
          isDisabled,
          disableAccept,
          setisDisabled,
        }}
      />
      <StageMakePayment
        content={{
          getDataById,
          handleOpenandCloseModal,
          openModal,
          handleToast,
          clickedBidChatUser,
          isDisabled,
          setisDisabled,
          disablePayment,
        }}
      />
      <StageCloseTransaction
        content={{
          openModal,
          handleToast,
          getDataById,
          handleOpenandCloseModal,
          userToken,
          bidUsers,
          disableCloseAccount,
          handleHideRating,
        }}
      />
    </div>
  );
}

export default TrackTransactionStage;
